<app-modal-shell [config]="modalConfig">
  <form modal-content [formGroup]="form" class="date-form" (ngSubmit)="onConfirm()">
    <app-date-picker
      class="full-width"
      label="Fecha de inicio"
      formControlName="validFrom"
      [min]="minDate"
      [max]="maxDate"
      [errorMessages]="{
        required: 'La fecha de inicio es requerida.',
        matDatepickerParse: 'Ingresa una fecha valida.',
        matDatepickerMin: 'La fecha no puede ser anterior a la fecha de nacimiento.',
        matDatepickerMax: 'La fecha no puede ser posterior a hoy.',
        futureDate: 'La fecha no puede ser posterior a hoy.'
      }">
    </app-date-picker>
  </form>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="button" (click)="onConfirm()">
      Continuar
    </button>
  </ng-container>
</app-modal-shell>
